import { useState } from "react";
import TecoICon_one from "../../common/images/cusT-3.png";
import TecoICon_two from "../../common/images/cusT-4.png";
import TecoICon_three from "../../common/images/cusT-2.png";
import TecoICon_four from "../../common/images/cusT-1.png";

import TecoICon_nine from "../../common/images/cus-T-13.png";
import TecoICon_eleven from "../../common/images/cus-T-7.png";
import TecoICon_twelve from "../../common/images/cus-T-12.png";
import TecoICon_14 from "../../common/images/cus-T-14.png";
import TecoICon_13 from "../../common/images/cus-T-5.png";
import TecoICon_15 from "../../common/images/cus-T-6.png";
import TecoICon_16 from "../../common/images/mongo-db.png";
import TecoICon_21 from "../../common/images/cus-T-21.png";
import TecoICon_22 from "../../common/images/cus-T-22.png";
import TecoICon_23 from "../../common/images/cus-T-23.png";
import TecoICon_24 from "../../common/images/cus-T-24.png";

import { IoIosArrowForward } from "react-icons/io";

const categories = {
  "Programming Languages": [
    { name: "PYTHON", img: TecoICon_one },      
    { name: "JAVASCRIPT", img: TecoICon_two },  
    { name: "PHP", img: TecoICon_three },      
    { name: "C#", img: TecoICon_four },       
  ],
  Frameworks: [
    { name: "EXPRESS", img: TecoICon_21 },      
    { name: "NEST", img: TecoICon_22 },     // cusT-6.png
    { name: "JQUERY", img: TecoICon_23 },   // cusT-7.png
    { name: "NEXT.JS", img: TecoICon_24 },       // cusT-8.png
  ],
  Databases: [
    { name: "MYSQL", img: TecoICon_nine },         // cusT-9.png
    { name: "MONGODB", img: TecoICon_16 },        // cusT-10.png
    { name: "POSTGRESQL", img: TecoICon_14 },  // cusT-11.png
  ],
  "Cloud Solutions": [
    { name: "AWS", img: TecoICon_eleven },
    { name: "GOOGLE", img: TecoICon_twelve },
    { name: "CLOUD ", img: TecoICon_15 },
    { name: "AZURE", img: TecoICon_13 },
  ],
};


export default function Technologies() {
  const [activeTab, setActiveTab] = useState("Programming Languages");

  return (
    <section className="max-w-[1080px] mx-auto md:px-10 px-5 py-7">
      {/* Header */}
      <div className="text-center mb-10">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
          Technologies We Use
        </h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>        <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto">
          We leverage a wide range of modern technologies and frameworks to
          develop custom software, including:
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Sidebar */}
        <div className="w-full md:w-1/3 space-y-5 bg-[#F5F5F5] rounded-md p-3">
          {Object.keys(categories).map((category) => (
          <button
          key={category}
          onClick={() => setActiveTab(category)}
          className={`w-full text-left px-4 py-3 font-semibold rounded-lg flex items-center justify-between text-sm sm:text-base ${
            activeTab === category
              ? "bg-yellow-400 text-white font-semibold shadow"
              : "bg-white text-black border border-gray-200"
          }`}
        >
          {category}
          <IoIosArrowForward
            className={`text-xl transition-transform duration-300 ${
              activeTab === category ? "text-white translate-x-1" : "text-webYellow"
            }`}
          />
        </button>
          ))}
        </div>

        {/* Grid Content */}
        <div className="w-full md:w-2/3 grid grid-cols-2  gap-4">
          {categories[activeTab].map((tech, i) => (
            <div
              key={i}
              className="border-[1px] flex flex-col justify-around bg-gradient-to-b from-[#ECF2F7] to-white border-dashed border-yellow-400 rounded-md p-4  text-center hover:shadow transition"
            >
              <img
                src={tech.img}
                alt={tech.name}
                className="mx-auto w-[100px] h-[80px]   object-contain mb-2 "
              />
              <p className="w-[60px] h-1 bg-[#065492] rounded-full my-2 mx-auto" ></p>
              <h3 className="text-sm sm:text-base md:text-lg font-bold text-[#065492]">
                {tech.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
